export const paymentHistoryConstants = {
  GET_PAYMENT_HISTORY: "GET_PAYMENT_HISTORY",
  PAYMENT_HISTORY_PAGINATION: "PAYMENT_HISTORY_PAGINATION",
};

export const USER_ROLE_MAPPING = {
  1: "Super Admin",
  2: "Admin",
  3: "Agent",
  4: "Customer",
};

export const PLAN_TYPES = {
  MONTHLY: 1,
  SEASONAL: 2,
  ANNUAL: 3,
};

export const PLAN_TYPES_MAPPING = {
  [PLAN_TYPES.MONTHLY]: "Monthly",
  [PLAN_TYPES.SEASONAL]: "Biannual",
  [PLAN_TYPES.ANNUAL]: "Annual",
};

export const roleSelectOptions = [
  { id: 1, label: "Agent", value: 3 },
  { id: 2, label: "Customer", value: 4 },
];

export const planSelectOptions = [
  { id: 1, label: "Standard", value: 1 },
  { id: 2, label: "Beginner", value: 2 },
  { id: 3, label: "Professional", value: 3 },
  { id: 4, label: "Premium", value: 4 },
];

export const planTypeSelectOptions = [
  { id: 1, label: "Monthly", value: 1 },
  { id: 2, label: "Biannual", value: 2 },
  { id: 3, label: "Annual", value: 3 },
];
